import { Delete } from '../helpers';

const DeleteCampaign = async (campaignUuid: string): Promise<void> => {
  return Delete({ path: `/v3/admin/auth/campaigns/${campaignUuid}`, ignoreResponse: true });
};

export default DeleteCampaign;
